module.controller('smsManageCtrl', ['$scope', '$rootScope', '$state', '$http', '$q', 'Transform', 'Session', 'baseURI', 'OVERLAY', 'accountService', '$stateParams',
  function ($scope, $rootScope, $state, $http, $q, Transform, Session, baseURI, OVERLAY, accountService, $stateParams){
    var notificationUrl = baseURI + 'notification';
    var subUrl = baseURI + 'card/sub-cards';
    $scope.alert = {};
    $scope.alert.errorShown = false;
    $scope.loadingSubs = false;
    $scope.overlay = OVERLAY['member.home.profile/smsmanage'];
    $scope.primary = {};
    $scope.username = $stateParams.username;
    $scope.cards = accountService.getAccounts();



    $scope.getCurrentAccount = function() {
      if ($scope.cards && $scope.cards.length > 0 && $scope.cards[0].firstName) {
        $scope.primary.firstName = $scope.cards[0].firstName;
        $scope.primary.lastName = $scope.cards[0].lastName;
        for (var i = 0; i < $scope.cards.length; i++) {
          if ($scope.username === $scope.cards[i].username) {
            return i;
          }
        }
      }
    };

    $scope.getCardAccounts = function() {
      if ($scope.cards && $scope.cards.length > 0 && $scope.cards[0].firstName) {
        $scope.primary.firstName = $scope.cards[0].firstName;
        return $scope.cards;
      }
    };

    $scope.getCardUsername = function() {
      if ($scope.$$prevSibling.accounts && $scope.$$prevSibling.accounts.length > 0 && $scope.$$prevSibling.accounts[0].firstName) {
        return $scope.username;
      }
    };

    var getPrimaryNotification = function(){
      $http.get(notificationUrl).then(function (resp){
        var data = resp.data;

        if(data.Success){
          $scope.primary.CardAlert = ((data.Data.Subscribed == 'true') ? 'Enabled' : 'Disabled');
          $scope.primary.PhoneNumber = data.Data.PhoneNumber || '';
        }
      });
    };
    var getSubNotification = function(subs){
      var promises = subs.map(function(sub, index){
        var deffered = $q.defer();
        $http({
          method: 'GET',
          url: notificationUrl + '/?Username=' + sub.Username,
        }).then(function (resp){
          var data = resp.data;

          deffered.resolve(data);
        }).catch(function(error){
          deffered.resolve(error);
        });
        return deffered.promise;
      });
      $q.all(promises).then(function (dataArray){
        var success = true;
        $scope.loading = false;
        for(var req in dataArray){
          if(!dataArray[req].Success){
            success = false;
            //$scope.alert.alertShown = true;
            break;
          }
        }
        if(success){
          applySubNotifications(dataArray);
        }
      });
    };
    var applySubNotifications = function(subRes){
      $scope.subCards.map(function(sub, index){
        $scope.subCards[index].CardAlert = ((subRes[index].Data.Subscribed == 'true') ? 'Enabled' : 'Disabled');
        $scope.subCards[index].PhoneNumber = subRes[index].Data.PhoneNumber || '';
      });
    };
    var updateNotifications = function(){
      var updates = [];
      if($scope.primary.PhoneNumber)
        updates.push($scope.primary);
      var subUpdates = $scope.subCards;
      for(var sub in subUpdates){
        // Check if phonenumber is not blank
        if(subUpdates[sub].PhoneNumber)
          updates.push(subUpdates[sub]);
      }
      var promises = updates.map(function(update, index){
        var deffered = $q.defer();
        // replace all non digits with none
        var numericPhoneNumber = update.PhoneNumber.replace(/\D+/g, '');
        var updateRequest = {
          PhoneNumber: numericPhoneNumber,
          Subscribe: (update.CardAlert == 'Enabled' ? true : false),
          Username: update.Username || ''
        };
        $http({
          method: 'POST',
          url: notificationUrl,
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
          },
          data: Transform.encode(updateRequest)
        }).then(function(resp){
          var data = resp.data;

          deffered.resolve(data);
        }).catch(function(error){
          deffered.resolve(error);
        });
        return deffered.promise;
      });
      $q.all(promises).then(function (dataArray){
        var success = true;
        for(var req in dataArray){
          if(!dataArray[req].Success){
            success = false;
            //$scope.alert.alertShown = true;
            break;
          }
        }
        if(success){
          $scope.alert.successMessage = 'You have updated your text alerts';
          $scope.alert.successShown = true;
          $state.go('member.home.profile/smsmanage.step3');
        }
      });
    };
    $scope.attemptSubmission = function(formData){
      if(formData.$valid){
        $scope.alert.errorShown = false;
        $state.go('member.home.profile/smsmanage.step2');
      } else {
        $scope.alert.errorShown = true;
        $scope.attempted = true;
      }
    };
    $scope.processForm = function(){
      updateNotifications();
    };
    var getSubs = function(){
      $scope.loadingSubs = true;
      $http.get(subUrl, {cache: true}).then(function (resp){
        var subCards = resp.data.Data || [];
        getSubNotification(subCards);
        $scope.subCards = subCards;
        $scope.loadingSubs = false;
      }).catch(function (error){
        $scope.loadingSubs = false;
        console.log('err', error);
      });
    };
    getPrimaryNotification();
    if(Session.getHasSubs()){
      getSubs();
    }
  }]);
